import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import Box from '../../../Box';

import constructionPropTypes from './Header.types';

import {
  Wrapper,
  StyledImg,
  BoxWrapper,
  TextWrapper,
  ConstructionWrapper
} from './Header.styles';

const WrapperDiv = styled.div`
  @media (max-width: 1150px) {
    padding-top: 30px;
  }
`;

const Constructions = ({
  activeConstruction,
  constructions,
  onConstructionChange
}) => (
  <WrapperDiv>
    <Wrapper>
      {
      constructions.map((key) => (
        <BoxWrapper key={key.attributes.slope}>
          <Box
            pointer
            active={key.id === activeConstruction}
            onClick={() => { onConstructionChange(key.id); }}
            clear
          >
            <ConstructionWrapper title={key.attributes.name}>
              <StyledImg src={key.attributes.img} alt={key.attributes.name} />
              {
                window.innerWidth > 640 ? (
                  <TextWrapper>{key.attributes.name}</TextWrapper>
                ) : null
              }
            </ConstructionWrapper>
          </Box>
        </BoxWrapper>
      ))
    }
    </Wrapper>
  </WrapperDiv>
);

Constructions.propTypes = {
  activeConstruction: PropTypes.number.isRequired,
  constructions: PropTypes.arrayOf(constructionPropTypes).isRequired,
  onConstructionChange: PropTypes.func.isRequired
};

export default Constructions;
